export enum FilterOperatorKey {
    EQUALS = "EQUALS",
    LT = "LT",
    GT = "GT",
    LTE = "LTE",
    GTE = "GTE",
    NOT_EQUALS = "NOT_EQUALS",
    LIKE = "LIKE",
    ILIKE = "ILIKE",
    AND = "AND",
    OR = "OR",
    IN = "IN",
    BETWEEN = "BETWEEN",
    IS_NULL = "IS_NULL",
    NOT_NULL = "NOT_NULL",
    NOT_LIKE = "NOT_LIKE",
    NOT_IN = "NOT_IN",
    NOT_BETWEEN = "NOT_BETWEEN",
    STARTS_WITH = "STARTS_WITH",
    ENDS_WITH = "ENDS_WITH",
  }